import { useTranslation } from "react-i18next";
import TextInput from "../../components/inputs/textInput";
import { useFormik } from "formik";
import * as yup from "yup";

const ForgotPass = () => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    email: yup.string().email(t("invalidEmail")).required(t("requiredField")),
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });
  return (
    <form onSubmit={formik.handleSubmit}>
      <h1 className="my-4 text-3xl font-bold text-white">{t("forgotPassword")}</h1>
      <h2 className="my-4 text-lg text-white"> {t("noWorries")}</h2>
      <TextInput
        formik={formik}
        name={"email"}
        label={t("email")}
        placeholder={"hello@gmail.com"}
      />

      <button
        type="submit"
        className="w-full px-4 py-2 my-4 transition-colors rounded-lg bg-mainBlue hover:bg-blue-700"
      >
        {t("send")}
      </button>
    </form>
  );
};

export default ForgotPass;
